/* eslint-disable no-param-reassign, consistent-return */

/**
 * Easy In And Out animation for scrolling element to top
 * @param {HTMLElement} scrollingElement Element witch should be scrolled
 * @param {Number} duration Time of animation
 *
 * @returns {Number} Last scrollTop value
 */
export default function (scrollingElement, duration = 1000) {
  if (!scrollingElement || scrollingElement.scrollTop === 0) return;

  const scrollParam = scrollingElement.scrollTop / 2;
  let scrollCount = 0;
  let curTimestamp = null;

  function step(tmpTimestamp) {
    if (curTimestamp !== null) {
      scrollCount += (Math.PI * (tmpTimestamp - curTimestamp)) / duration;
      if (scrollCount >= Math.PI) {
        scrollingElement.scrollTop = 0;

        return scrollingElement.scrollTop;
      }
      scrollingElement.scrollTop =
        scrollParam + scrollParam * Math.cos(scrollCount);
    }
    curTimestamp = tmpTimestamp;
    window.requestAnimationFrame(step);
  }

  window.requestAnimationFrame(step);
}
